import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import { getPlainTextPreviewForRawRichTextContent, getShortenedString } from '../../../../models/UiUtils';
import { baseStyleSheet } from '../../../styles/styles';
import { styleSheet } from './styles';

export function SocialCampaignTemplateCardSummary({
	bigScreenCutoff,
	content,
	ctaClicked,
	summary,
}: {
	bigScreenCutoff: number;
	content?: Api.IRawRichTextContentState;
	ctaClicked?: () => void;
	summary?: string;
}) {
	// Social drafts come from the post endpoints, which carry content rather than a server-built preview.
	const { text, truncated } = summary?.trim()
		? { text: getShortenedString(summary.trim(), bigScreenCutoff), truncated: summary.trim().length > bigScreenCutoff }
		: getPlainTextPreviewForRawRichTextContent(content, { maxCharCount: bigScreenCutoff, maxLineCount: 4 });

	return (
		<div className={css(styleSheet.textContainer)}>
			<p className={css(styleSheet.body)}>
				<span>{text}</span>
				{truncated ? (
					<a onClick={ctaClicked} className={css(baseStyleSheet.fontBold, styleSheet.clickNav)}>
						... Read more
					</a>
				) : null}
			</p>
		</div>
	);
}
